import "./MaintenancePage.scss";
import brandImage from "../../assets/logo512.png";

function MaintenancePage() {
  return (
    <main className="maintenance-page">
      <div className="maintenance-page__glow maintenance-page__glow--left" />
      <div className="maintenance-page__glow maintenance-page__glow--right" />

      <section className="maintenance-page__card">
        <img
          className="maintenance-page__logo"
          src={brandImage}
          alt="Alex Fish"
        />

        <p className="maintenance-page__eyebrow">
          Временно не приемаме поръчки
        </p>
        <h1>В момента се извършва поддръжка</h1>
        <p className="maintenance-page__copy">
          Сайта е временно недостъпен поради извършване на важни подобрения и
          оптимизации. Работим усилено, за да ви предоставим по-добро
          изживяване.
        </p>
        <p className="maintenance-page__footer">AlexFish Delivery</p>
      </section>
    </main>
  );
}

export default MaintenancePage;
